import React from 'react';
import {LANDING_PAGE_URL} from "../../../../Globals.ts";
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";
import {handleLinkClick} from "../../../../Utils/misc/openLink.ts";

interface RefillBalanceProps {}

const RefillBalance: React.FC<RefillBalanceProps> = () => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const url = `${LANDING_PAGE_URL}/manage-account`;

    return (
        <button
            onClick={(e) => handleLinkClick(e, environment, vscode, url)}
            className="px-2.5 py-1 rounded-lg text-red-600 hover:text-red-500 bg-neutral-950 dark:bg-neutral-800 hover:bg-neutral-300 dark:hover:bg-neutral-700 bg-opacity-10 hover:bg-opacity-20"
        >
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
            >
                Refill Balance
            </a>
        </button>
    );
};

export default RefillBalance;